import { render } from "./Landscape.vue?vue&type=template&id=c5ca0f60"
import script from "./Landscape.vue?vue&type=script&lang=js"
export * from "./Landscape.vue?vue&type=script&lang=js"

import "./Landscape.vue?vue&type=style&index=0&id=c5ca0f60&lang=scss"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__